import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Document(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M21.6 4.8L24 7.2v14.4a2.4 2.4 0 01-2.4 2.4H2.4A2.4 2.4 0 010 21.6V2.4A2.4 2.4 0 012.4 0h14.4l2.4 2.4 2.4 2.4zm0 16.8V8.4H18A2.4 2.4 0 0115.6 6V2.4H2.4v19.2h19.2zM4.8 13.177v-2.4h14.4v2.4H4.8zm0-4.777V6h8.4v2.4H4.8zm0 9.577v-2.4h9.6v2.4H4.8z"
  }));
}

export { Document };
//# sourceMappingURL=Document.js.map